import { createLeadTask } from "api/Leads";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useCreateFollowUp = () => {
    const queryClient = useQueryClient();

    return useMutation(createLeadTask, {
        onSuccess: () => {
            toast.success("Task Created Successfully");
            queryClient.invalidateQueries(['widgetData', 'Leads Pendings List'])

        },
        onError: () => {
            toast.error("Something went wrong");
        },
    });
};
